export default __webpack_public_path__ + "static/media/nothing.f0461aaa.png";